// @flow
import React, { Component } from 'react'
import { Field, reduxForm } from 'redux-form'
import { Link } from 'react-router'
import styled from 'styled-components'
import AuthCard from '../../../../components/AuthCard'
import Input from '../../../../components/Input'
import Button from '../../../../components/Button'
import Errors from '../../../../components/Errors'
import FacebookAuth from '../../../../components/FacebookAuth'

const FooterLink = styled(Link)`
  padding: 5px 0;
  color: rgb(120, 130, 140);
  text-transform: uppercase;
  font-size: 12px;
  display: block;
  text-align: center;

  &:hover {
    color: rgb(100, 110, 120);
    text-decoration: none;
  }
`

type Props = {
  errors: Object,
  onSubmit: Function,
  submitting: boolean,
  handleSubmit: Function
}

class SignupForm extends Component {
  props: Props

  handleSubmit = (data) => this.props.onSubmit({ user: data })

  render() {
    const { handleSubmit, submitting } = this.props

    return (
      <AuthCard>
        <form onSubmit={handleSubmit(this.handleSubmit)}>
          <h5 style={{ color: 'rgb(120,130,140)', marginBottom: '1.5rem' }}>
            Sign up
          </h5>
          <FacebookAuth signup />
          <hr />
          <Field
            name="name"
            type="text"
            label="Full name"
            component={Input}
            style={{ marginBottom: '1rem' }}
          />
          <div style={{ marginBottom: '1rem' }}>
            <Field name="email" type="email" label="Email" component={Input} />
            <Errors name="email" errors={this.props.errors} />
          </div>
          <Field
            name="password"
            type="password"
            label="Password"
            component={Input}
            style={{ marginBottom: '1rem' }}
          />
          <Button color="primary" disabled={submitting} animating={submitting}>
            Sign up
          </Button>
          <div
            style={{
              fontSize: '85%',
              color: 'rgb(150,160,170)',
              margin: '1rem 0'
            }}
          >
            By continuing you are agreeing to Kief Realty&apos;s{' '}
            <Link to="/privacy-policy">Privacy Policy</Link> and{' '}
            <Link to="/terms-of-service">Terms of Service</Link>
          </div>
          <hr />
          <FooterLink to="/login">Have an account?</FooterLink>
        </form>
      </AuthCard>
    )
  }
}

const validate = (values) => {
  const errors = {}
  if (!values.name) {
    errors.name = 'Please enter name'
  }
  if (!values.email) {
    errors.email = 'Please enter email'
  } else if (!/\S+@\S+\.\S+/.test(values.email)) {
    errors.email = 'Please enter valid email'
  }
  if (!values.password) {
    errors.password = 'Please enter password'
  } else if (values.password.length < 6) {
    errors.password = 'Minimum 6 characters'
  }
  return errors
}

export default reduxForm({
  form: 'signup',
  validate
})(SignupForm)



// WEBPACK FOOTER //
// ./src/views/Signup/components/SignupForm/index.js